/* eslint-disable max-len */
import React, {
  useState, ChangeEvent, forwardRef,
  useMemo,
} from 'react';
import {
  Button,
  Dialog, DialogContent, DialogTitle, Grid, IconButton, TextField, Zoom,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { TransitionProps } from '@mui/material/transitions';
import { useDispatch, useSelector } from 'react-redux';
import styles from './pipeStyle.module.scss';
import { BayValuesSet, BaylengthResponse, PipeStructureProps } from '../../utils/type';
import { RootState } from '../../../../redux/rootState';
import ConfirmationModal from '../../../../Common/ConfirmationModal/ConfirmationModal';
import { ConfirmationIcon } from '../../../../assets/Icons/AnalystIcons/ConfirmationIcon';
import { updateBayLengthStart } from '../../redux/baylength/baylengthSlice';
import localStorageConstants from '../../../../utils/LocalStorageConstants';
import { ANALYST_ROLE_ID } from '../../../../Routes/constant';

const Transition = forwardRef((
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>,
) => <Zoom ref={ref} {...props} />);

export default function PipeStructure({
  setOpenFrom,
  show,
}:PipeStructureProps) {
  const {
    bayLengthDetails, jobId, vesselId,
  } = useSelector((state:RootState) => state.BayLengthReducer);
  const roleId = localStorage.getItem(localStorageConstants.ROLE_ID);

  const [spacingValues, setSpacingValues] = useState(bayLengthDetails.spacingValues);
  const [finalSpacing, setFinalSpacing] = useState(bayLengthDetails.spacingValues);
  const [total, setTotal] = useState(Number(bayLengthDetails?.bayLengthTubes));
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [isGenerated, setIsGenerated] = useState(false);

  const dispatch = useDispatch();

  // useEffect(() => {
  //   if (isBayLengthChanged) {
  //     const len = (Number(bayLengthDetails?.bayLengthSupport) || 0) + 1;
  //     const value = (Number(bayLengthDetails?.bayLengthTubes) / len);
  //     const temp = Array(len).fill(value);
  //     setSpacingValues(temp);
  //     setFinalSpacing(temp);
  //   } else {
  //     setSpacingValues(bayLengthDetails?.spacingValues || []);
  //     setFinalSpacing(bayLengthDetails?.spacingValues || []);
  //   }
  //   setTotal(Number(bayLengthDetails?.bayLengthTubes));
  // }, [isBayLengthChanged, bayLengthDetails]);

  const handleBayValueSet = ():BayValuesSet[] => {
    const data:BayValuesSet[] = [];
    let totalSum = 0;
    const n = finalSpacing?.length;

    finalSpacing?.slice(0, n - 1).forEach((value, index) => {
      totalSum += Number(value);
      const obj:BayValuesSet = {
        bayValue: Number(value),
        parentLeftMargin: totalSum,
        childLeftMargin: totalSum - Number(value),
        bayNumber: n - index,
        supportNumber: n - index - 1,
        childWidth: index >= 1 ? Number(value) - 5 : Number(value),
        childMargin: index >= 1 ? '5px' : '',
      };
      data.push(obj);
    });

    return data;
  };

  const bayValuesSet:BayValuesSet[] = useMemo(() => handleBayValueSet(), [finalSpacing]);

  const lastTextField = useMemo(() => Number(finalSpacing?.[finalSpacing.length - 1]), [finalSpacing]);

  const handleSpacingValue = (value:string, index: number) => {
    const temp = [...spacingValues];
    // setTotal((prev) => prev - (temp[index]) + Number(value));
    setTotal((prev) => parseFloat((prev - temp[index] + Number(value)).toFixed(2)));
    temp[index] = Number(value);
    setSpacingValues(temp);
    setIsGenerated(false);
  };

  const handleGenerate = () => {
    if (total === Number(bayLengthDetails.bayLengthTubes)) {
      setFinalSpacing(spacingValues);
      setIsGenerated(true);
    } else {
      setShowConfirmationModal(true);
    }
  };

  const handleSave = () => {
    if (total !== Number(bayLengthDetails.bayLengthTubes)) {
      setShowConfirmationModal(true);
      return;
    }
    const payload:BaylengthResponse = {
      BayLengthId: `${jobId}-${vesselId}`,
      JobOrder: jobId,
      TubeLength: bayLengthDetails.bayLengthTubes,
      Support: bayLengthDetails.bayLengthSupport,
      Configuration: [...finalSpacing],
      VesselId: vesselId,
    };

    dispatch(updateBayLengthStart(payload));
    setOpenFrom();
  };

  let runningLeft = 0;
  const regExDecPoint = /^(\d{1,3}|\d{0,3}\.\d{0,2}|\.\d{1,2})$/;

  return (
    <div>
      <Dialog
        maxWidth="lg"
        PaperProps={{
          className: 'paperStyle',
        }}
        open={show}
        transitionDuration={500}
        TransitionComponent={Transition}
        keepMounted
        onClose={setOpenFrom}
        onClick={(e) => e.stopPropagation()}
      >
        <DialogTitle className="modalHeaderTitle">
          Bay Lengths
          <IconButton
            aria-label="close"
            onClick={setOpenFrom}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent style={{ padding: '16px 24px' }}>
          <div className={styles.divContainer}>
            <div className={styles.innerDiv}>
              <div style={{
                display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: 'calc(100% + 80px)', marginLeft: '-40px', marginRight: '-40px',
              }}
              >
                <div className={styles.testTextStyle}>Opposite Test End</div>
                <div className={styles.testTextStyle}>Test End</div>
              </div>
              <div style={{
                display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%',
              }}
              >
                {/* <div className={styles.testTextStyle}>Opposite Test End</div> */}
                <div className={styles.container}>
                  <div style={{
                    textAlign: 'center', marginBottom: '45px', borderBottom: '3px solid black',
                  }}
                  >
                    {`${Number(bayLengthDetails.bayLengthTubes)}"`}
                  </div>
                  <div className={`${styles.pipe} ${styles.horizontal}`} style={{ width: '100%' }}>
                    {/* {bayValuesSet.map((valueSet:BayValuesSet) => (
                      <>
                        <div
                          key={`${valueSet.bayValue}-${valueSet.supportNumber}`}
                          className={styles.verticalLine}
                          style={{ left: `${valueSet.parentLeftMargin}%` }}
                        />
                        <span style={{ width: valueSet.childWidth, left: `${valueSet.parentLeftMargin}%`, marginLeft: valueSet.childMargin }} className={styles.AllText}>
                          {valueSet.bayValue.toFixed(2)}
                        </span>
                        <span style={{ width: valueSet.childWidth, left: `${valueSet.parentLeftMargin}%`, marginLeft: valueSet.childMargin }} className={styles.bayLabel}>{`Bay ${valueSet.bayNumber}`}</span>
                        <span style={{ width: valueSet.childWidth, left: `${valueSet.parentLeftMargin}%`, marginLeft: valueSet.childMargin }} className={styles.SupportLabel}>{`Support #${valueSet.supportNumber}-->`}</span>
                      </>
                    ))} */}
                    {bayValuesSet.map((valueSet: BayValuesSet) => {
                      const widthPercent = (valueSet.bayValue / Number(bayLengthDetails.bayLengthTubes)) * 100;
                      const leftPercent = runningLeft;
                      runningLeft += widthPercent;

                      return (
                        <React.Fragment key={`${valueSet.bayValue}-${valueSet.supportNumber}`}>
                          {/* Vertical line at start */}
                          <div
                            className={styles.verticalLine}
                            style={{ left: `${runningLeft}%` }}
                          />

                          {/* Bay width label */}
                          <span
                            className={bayValuesSet?.length > 15 ? styles.smallAllText : styles.AllText}
                            style={{
                              width: `calc(${widthPercent}% - 10px)`,
                              left: `calc(${leftPercent}% + 5px)`,
                              fontSize: bayValuesSet?.length > 15 ? '10px !important' : '13px',
                            }}
                          >
                            {valueSet.bayValue.toFixed(2)}
                            &quot;
                          </span>

                          {/* Bay number */}
                          <span
                            className={bayValuesSet?.length > 15 ? styles.smallBayLabel : styles.bayLabel}
                            style={{
                              width: `calc(${widthPercent}% - 10px)`,
                              left: `calc(${leftPercent}% + 5px)`,
                            }}
                          >
                            {bayValuesSet?.length > 15 ? 'B' : 'Bay'}
                            {valueSet.bayNumber}
                          </span>

                          {/* Support number */}
                          <span
                            className={styles.SupportLabel}
                            style={{
                              width: `${widthPercent}%`,
                              left: `${leftPercent}%`,
                            }}
                          >
                            {`S${valueSet.supportNumber}➜`}
                          </span>
                        </React.Fragment>
                      );
                    })}

                  </div>
                  <span className={bayValuesSet?.length > 15 ? styles.smallLastText : styles.lastText} style={{ left: `calc(${runningLeft}% + 3px)` }}>{`${lastTextField?.toFixed(2)}"`}</span>
                  <span className={bayValuesSet?.length > 15 ? styles.smallLastBayLabel : styles.lastBayLabel} style={{ left: `calc(${runningLeft}% + 3px)` }}>{bayValuesSet?.length > 15 ? 'B1' : 'Bay 1'}</span>
                </div>
                {/* <div className={styles.testTextStyle}>Test End</div> */}
              </div>
              {/* <div style={{ marginTop: '100px', display: 'flex', width: '100%' }}>
                {spacingValues?.map((value, index) => (
                  <div key={`${value}-${index + 1}`} style={{ paddingRight: '10px' }}>
                    <TextField
                      autoFocus
                      size="small"
                      type="number"
                      InputProps={{ inputProps: { min: 0 } }}
                      style={{ backgroundColor: 'white', width: '110px' }}
                      value={spacingValues?.[index]}
                      onChange={(e: ChangeEvent<HTMLInputElement>) => {
                        handleSpacingValue((e.target.value), index);
                      }}
                      disabled={roleId === ANALYST_ROLE_ID}
                    />
                  </div>
                ))}
              </div> */}
              <Grid container spacing={2} style={{ marginTop: '100px', marginBottom: '30px' }}>
                {spacingValues?.map((value, index) => (
                  <Grid item xs={4} sm={3} md={1.5} key={`${index + 1}`}>
                    <div className="div_label_text">
                      <label className={styles.label_Style_job}>{`Bay ${spacingValues.length - index}`}</label>
                      <TextField
                        autoFocus={index === 0}
                        size="small"
                        type="number"
                        InputProps={{ inputProps: { min: 0 } }}
                        fullWidth
                        style={{ backgroundColor: 'white' }}
                        value={spacingValues?.[index]}
                        onChange={(e: ChangeEvent<HTMLInputElement>) => {
                          if (e.target.value.trim()?.length > 0 && !regExDecPoint.test(e.target.value)) {
                            return;
                          }
                          handleSpacingValue(e.target.value, index);
                        }}
                        disabled={roleId === ANALYST_ROLE_ID}
                      />
                    </div>
                  </Grid>
                ))}
              </Grid>
            </div>
            <div className={styles.BayDiv}>
              <div style={{ display: 'flex', flexDirection: 'row', gap: '10px' }}>
                <div className="div_label_text">
                  <label className={styles.label_Style_job}>Tube length</label>
                  <TextField
                    size="small"
                    style={{ backgroundColor: 'white', width: '140px' }}
                    value={Number(bayLengthDetails.bayLengthTubes)}
                    disabled
                  />
                </div>
                <div className="div_label_text">
                  <label className={styles.label_Style_job}>Sum of Bay lengths</label>
                  <TextField
                    size="small"
                    style={{ backgroundColor: 'white', width: '140px' }}
                    value={total}
                    disabled
                  />
                  {(bayLengthDetails?.bayLengthTubes && total !== Number(bayLengthDetails.bayLengthTubes)) && <p className="bayLengthErr">*Sum of Bay lengths must be equal to Tube length</p>}
                </div>
              </div>
              {!(roleId === ANALYST_ROLE_ID) && (
              <div className={styles.BayLengthBtn}>
                <div className="save_and_next_div">
                  <Button onClick={handleGenerate} className="button_save_and_next">Generate</Button>
                </div>
                <div className={styles.BayGenBtn}>
                  <Button onClick={isGenerated ? handleSave : () => {}} className={isGenerated ? 'button_save_and_next' : 'button_cancel cursorNotAllowed'}>Save</Button>
                </div>
              </div>
              )}
            </div>
          </div>
        </DialogContent>
      </Dialog>
      {
        showConfirmationModal && (
          <ConfirmationModal
            confirmationIcon={<ConfirmationIcon />}
            show={showConfirmationModal}
            setOpenFrom={() => setShowConfirmationModal(false)}
            readOnly
            text="Sum of Bay lengths is not equal to Tube length, Please check."
          />
        )
      }
    </div>
  );
}
